__turbopack_context__.v({
  "ant-checkbox-wrapper": "editor-composer-module__V3BjaG__ant-checkbox-wrapper",
  "assets": "editor-composer-module__V3BjaG__assets",
  "audioIcon": "editor-composer-module__V3BjaG__audioIcon",
  "audioLabel": "editor-composer-module__V3BjaG__audioLabel",
  "audioPreview": "editor-composer-module__V3BjaG__audioPreview",
  "cardDefault": "editor-composer-module__V3BjaG__cardDefault",
  "cardSelected": "editor-composer-module__V3BjaG__cardSelected",
  "cardTitle": "editor-composer-module__V3BjaG__cardTitle",
  "categories": "editor-composer-module__V3BjaG__categories",
  "categoriesList": "editor-composer-module__V3BjaG__categoriesList",
  "category": "editor-composer-module__V3BjaG__category",
  "categoryName": "editor-composer-module__V3BjaG__categoryName",
  "createEventButton": "editor-composer-module__V3BjaG__createEventButton",
  "darkTheme": "editor-composer-module__V3BjaG__darkTheme",
  "image": "editor-composer-module__V3BjaG__image",
  "initialPointIcon": "editor-composer-module__V3BjaG__initialPointIcon",
  "initialPointLabel": "editor-composer-module__V3BjaG__initialPointLabel",
  "initialPointPreview": "editor-composer-module__V3BjaG__initialPointPreview",
  "minimapCheckboxWrapper": "editor-composer-module__V3BjaG__minimapCheckboxWrapper",
  "modelIcon": "editor-composer-module__V3BjaG__modelIcon",
  "modelPreview": "editor-composer-module__V3BjaG__modelPreview",
  "noAssets": "editor-composer-module__V3BjaG__noAssets",
  "portalIcon": "editor-composer-module__V3BjaG__portalIcon",
  "portalLabel": "editor-composer-module__V3BjaG__portalLabel",
  "portalPreview": "editor-composer-module__V3BjaG__portalPreview",
  "root": "editor-composer-module__V3BjaG__root",
  "selectedCategory": "editor-composer-module__V3BjaG__selectedCategory",
  "videoIcon": "editor-composer-module__V3BjaG__videoIcon",
  "videoLabel": "editor-composer-module__V3BjaG__videoLabel",
  "videoPreview": "editor-composer-module__V3BjaG__videoPreview",
});
